import request from '@/utils/request'

// 列表
export function weworkPhoneList(params = {}) {
  return request({
    url: '/workWechat/phone/list',
    method: 'get',
    params
  })
}

// 删除
export function weworkPhoneDelete(data = {}) {
  return request({
    url: '/workWechat/phone/destroy',
    method: 'post',
    data
  })
}

// 修改
export function weworkPhoneModification(data = {}) {
  return request({
    url: '/workWechat/phone/update',
    method: 'post',
    data
  })
}

// 添加
export function weworkPhoneAddition(data = {}) {
  return request({
    url: '/workWechat/phone/add',
    method: 'post',
    data
  })
}

// 手机关联企微-企业列表筛选
export function filterCorplist(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/filterCorp',
    method: 'get',
    params
  })
}
// 手机关联企微-企业员工筛选
export function filterUser(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/filterUser',
    method: 'get',
    params
  })
}
// 手机关联企微用户创建
export function phoneRelationstore(data = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/store',
    method: 'post',
    data
  })
}

// 手机关联企微-转发源企业员工筛选
export function enterpriseEmployee(params = {}) {
  return request({
    url: '/spWorkWechat/spCorp/corpUsersList',
    method: 'get',
    params
  })
}

// 手机关联企微用户列表
export function phoneRelationindex(params = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/index',
    method: 'get',
    params
  })
}
// 手机关联企微用户删除
export function phoneRelationstoredelte(data = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/destroy',
    method: 'post',
    data
  })
}
// 手机关联企微用户列表
export function yunlist(params = {}) {
  return request({
    url: '/cloudPhone/instance/index',
    method: 'get',
    params
  })
}
// 获取登录云手机二维码
export function vephonesdkqrcode(data = {}) {
  return request({
    url: '/cloudPhone/workWechat/login',
    method: 'post',
    timeout: 60 * 1000,
    data
  })
}
// 提交二维码和验证码
export function workWechatVerifyCode(data = {}) {
  return request({
    url: '/cloudPhone/workWechat/verifyCode',
    method: 'post',
    timeout: 30 * 1000,
    data
  })
}
// 手机类型列表
export function phonelist(params = {}) {
  return request({
    url: '/workWechat/phone/typeList',
    method: 'get',
    params
  })
}
// 筛选列表（设备类型、软件类型）
export function filterList(params = {}) {
  return request({
    url: '/workWechat/phone/filterList',
    method: 'get',
    params
  })
}
// 企微登出
export function workWechatloginOut(data = {}) {
  return request({
    url: '/cloudPhone/workWechat/loginOut',
    method: 'post',
    data
  })
}
// 获取阿里云手机对应的ticket
export function getAliTicket(params = {}) {
  return request({
    url: '/cloudPhone/ali/getTicket',
    method: 'get',
    params
  })
}
// 获取腾讯云手机对应的token
export function getTencentToken(params = {}) {
  return request({
    url: '/cloudPhone/tx/getTokenKey',
    method: 'get',
    params
  })
}
// 重置员工推粉游标
export function esetBusinessCard(data = {}) {
  return request({
    url: '/spWorkWechat/wwScriptJob/resetBusinessCard',
    method: 'post',
    data
  })
}
// 手机关联员工保存前预检查
export function spWorkWechatphoneRelationcheck(data = {}) {
  return request({
    url: '/spWorkWechat/phoneRelation/check',
    method: 'post',
    data
  })
}
// 开始推送名片
export function openBusinessCardSwitch(data = {}) {
  return request({
    url: '/spWorkWechat/wwScript/businessCard/openBusinessCardSwitch',
    method: 'post',
    data
  })
}
